import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@ridango/core';

import { ProductsEpics, ProductsFacade, ProductActions } from './+state';
import { ProductGroupItemComponent } from './components/product-group-item/product-group-item.component';
import { ProductGroupListComponent } from './components/product-group-list/product-group-list.component';
import { ProductListItemComponent } from './components/product-list-item/product-list-item.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { ProductsService } from './products.service';
import { ProductService } from './service/product.service';

@NgModule({
    imports: [CoreModule, CommonModule, TranslateModule],
    declarations: [
        ProductGroupListComponent,
        ProductGroupItemComponent,
        ProductListComponent,
        ProductListItemComponent,
    ],
    providers: [ProductService, ProductsService, ProductActions, ProductsEpics, ProductsFacade],
    exports: [ProductGroupListComponent, ProductGroupItemComponent, ProductListComponent, ProductListItemComponent],
})
export class ProductsModule {}
